"use strict";
/**
 * Modal UI Components
 * Handles showing/hiding modals
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.showSettingsModal = showSettingsModal;
exports.hideSettingsModal = hideSettingsModal;
exports.showCredentialsModal = showCredentialsModal;
exports.hideCredentialsModal = hideCredentialsModal;
exports.showReAuthModal = showReAuthModal;
exports.hideReAuthModal = hideReAuthModal;
exports.showMarketSelectionModal = showMarketSelectionModal;
exports.hideMarketSelectionModal = hideMarketSelectionModal;
exports.showParallelMarketsModal = showParallelMarketsModal;
exports.hideParallelMarketsModal = hideParallelMarketsModal;
exports.showEventTypeModal = showEventTypeModal;
exports.hideEventTypeModal = hideEventTypeModal;
const settings_display_1 = require("./settings-display");
/**
 * Show settings modal
 */
function showSettingsModal() {
    const modal = document.getElementById("settings-modal");
    if (modal) {
        (0, settings_display_1.updateVersionDisplay)();
        modal.classList.remove("hidden");
    }
}
/**
 * Hide settings modal
 */
function hideSettingsModal() {
    const modal = document.getElementById("settings-modal");
    if (modal) {
        modal.classList.add("hidden");
    }
}
/**
 * Show API credentials modal
 */
function showCredentialsModal() {
    const modal = document.getElementById("credentials-modal");
    if (modal) {
        modal.classList.remove("hidden");
    }
}
/**
 * Hide API credentials modal
 */
function hideCredentialsModal() {
    const modal = document.getElementById("credentials-modal");
    if (modal) {
        modal.classList.add("hidden");
    }
}
/**
 * Show session-expiry re-authentication modal (phone-OTP flow)
 */
function showReAuthModal() {
    const modal = document.getElementById("reauth-modal");
    if (modal) {
        modal.classList.remove("hidden");
    }
}
/**
 * Hide session-expiry re-authentication modal
 */
function hideReAuthModal() {
    const modal = document.getElementById("reauth-modal");
    if (modal) {
        modal.classList.add("hidden");
    }
}
/**
 * Show market selection modal
 */
function showMarketSelectionModal() {
    const modal = document.getElementById("market-selection-modal");
    if (modal) {
        modal.classList.remove("hidden");
    }
}
/**
 * Hide market selection modal
 */
function hideMarketSelectionModal() {
    const modal = document.getElementById("market-selection-modal");
    if (modal) {
        modal.classList.add("hidden");
    }
}
function showParallelMarketsModal() {
    const modal = document.getElementById("parallel-markets-modal");
    if (modal) {
        modal.classList.remove("hidden");
    }
}
function hideParallelMarketsModal() {
    const modal = document.getElementById("parallel-markets-modal");
    if (modal) {
        modal.classList.add("hidden");
    }
}
/**
 * Show event type selection modal
 */
function showEventTypeModal() {
    const modal = document.getElementById("event-type-modal");
    if (modal) {
        modal.classList.remove("hidden");
    }
}
/**
 * Hide event type selection modal
 */
function hideEventTypeModal() {
    const modal = document.getElementById("event-type-modal");
    if (modal) {
        modal.classList.add("hidden");
    }
}
